export const commonHeaders = {
  "Content-Type": "application/json; charset=utf-8",
  'Access-Control-Allow-Origin':'*',
};
